const typePolicies = {
  Page: { keyFields: ['id'] },
};

export default typePolicies;
